<template>
  <div class="bill-page">
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="billSearchData"
      :isHaveExport="false"
      :isHaveAdd="false"
      :sizes="[10, 20, 50, 100]"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
    >
      <template #table>
        <BillTable :list="list" :loading="loading" />
      </template>
    </tableComponents>
  </div>
</template>

<script>
import BillTable from "./components/BillTable.vue";

export default {
  components: {
    BillTable,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      queryForm: {},
      paginationForm: {
        page: 1,
        page_size: 10,
      },
    };
  },
  computed: {
    billSearchData() {
      return () => [
        {
          title: "",
          type: "1",
          data: [
            {
              type: "date",
              arr: [],
              key: ["start_time", "end_time"],
              placeholder: "创建时间",
            },
          ],
        },
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "user_id", placeholder: "搜索用户ID" },
            { type: "text", key: "username", placeholder: "搜索用户名" },
            { type: "text", key: "nickname", placeholder: "搜索用户昵称" },
            { type: "text", key: "order_id", placeholder: "搜索账单单号" },
            {
              type: "select",
              key: "biz_type",
              option: [
                { id: "ad_income_user", title: "ad_income_user" },
                { id: "ad_income_platform", title: "ad_income_platform" },
              ],
              placeholder: "业务类型",
              onChange: () => {},
            },
            {
              type: "select",
              key: "source_type",
              option: [{ id: "accessad", title: "accessad" }],
              placeholder: "来源类型",
              onChange: () => {},
            },
            {
              type: "select",
              key: "biz_status",
              option: [{ id: "confirmed", title: "confirmed" }],
              placeholder: "业务状态",
              onChange: () => {},
            },
            {
              type: "select",
              key: "is_app",
              option: [
                { id: "0", title: "用户收益" },
                { id: "1", title: "平台收益" },
              ],
              placeholder: "收益归属",
              onChange: () => {},
            },
            {
              type: "select",
              key: "type",
              option: [
                { id: "increase", title: "increase" },
                { id: "decrease", title: "decrease" },
              ],
              placeholder: "增减方向",
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    async getBillList() {
      this.loading = true;
      try {
        const params = {
          ...this.paginationForm,
          ...this.queryForm,
        };

        if (this.$route.query.user_id) {
          params.user_id = this.$route.query.user_id;
        }

        const data = await this.$api.getBill.getBillList(params);
        this.total = data.data && data.data.count ? data.data.count : 0;
        this.list = data.data && data.data.list ? data.data.list : [];
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getBillList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.getBillList();
    },
    getSearch(form) {
      this.queryForm = form || {};
      this.paginationForm.page = 1;
      this.getBillList();
    },
  },
  created() {
    this.getBillList();
  },
  watch: {
    $route() {
      this.queryForm = {};
      this.paginationForm.page = 1;
      this.getBillList();
    },
  },
};
</script>
